/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AsiSvgInfoDto } from '../../models/asi-svg-info-dto';

export interface BlockedDaysSvgInfos$Params {
}

export function blockedDaysSvgInfos(http: HttpClient, rootUrl: string, params?: BlockedDaysSvgInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AsiSvgInfoDto>>> {
  const rb = new RequestBuilder(rootUrl, blockedDaysSvgInfos.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AsiSvgInfoDto>>;
    })
  );
}

blockedDaysSvgInfos.PATH = '/blocked-days/svgs';
